import telephoneCodes from '@/data/telephoneCodes'

// What an agent types in a search box is matched as text, never as a pattern, so a "+" or "(" cannot
// break the search, and without regard to case. A term that is a phone number, in any form the agent
// sees or types (0772-123-456, +256 772 123456, 772123456), also matches the stored msisdn
// (256772123456), because both are compared without the country's dialling code or the leading 0.

const PHONE_LIKE = /^[\d\s+()-]+$/

// The number without its dialling code or trunk 0, as digits. A value no longer than the prefix is
// kept whole, so typing "256" or "0" still means those digits rather than every number.
export function nationalNumber(value, countryCode) {
  const digits = String(value ?? '').replace(/\D/g, '')
  const dialling = telephoneCodes[countryCode] || ''

  if (dialling && digits.startsWith(dialling) && digits.length > dialling.length) return digits.slice(dialling.length)
  if (digits.startsWith('0') && digits.length > 1) return digits.slice(1)
  return digits
}

function phoneTerm(term, countryCode) {
  return PHONE_LIKE.test(term) ? nationalNumber(term, countryCode) : ''
}

// A test for one search term: matcher({ texts, phones }) is true when any text contains the term, or
// the term is a phone number that any of the phones contains, with or without the prefix, so the
// start of a number ("+256 77") finds it as well as the number as shown ("0772-123-456"). An empty
// term matches everything.
export function searchMatcher(term, countryCode) {
  const text   = String(term ?? '').trim().toLowerCase()
  const phone  = phoneTerm(text, countryCode)
  const digits = phone !== '' ? text.replace(/\D/g, '') : ''

  if (text === '') return () => true

  const phoneMatches = (value) =>
    nationalNumber(value, countryCode).includes(phone) || String(value).replace(/\D/g, '').includes(digits)

  return ({ texts = [], phones = [] }) =>
    texts.some((value) => value != null && String(value).toLowerCase().includes(text)) ||
    (phone !== '' && phones.some((value) => value != null && phoneMatches(value)))
}

// The term to send the server, whose search matches msisdn with LIKE: a phone number goes without its
// prefix, so it finds the stored msisdn. Any other term goes as typed.
export function serverSearchTerm(term, countryCode) {
  const text  = String(term ?? '').trim()
  const phone = phoneTerm(text, countryCode)
  return phone !== '' ? phone : text
}
